/**
 * Created by tofael on 3/21/17.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {Router, hashHistory} from 'react-router';
import {Provider} from "react-redux"
import ThemeDefault from './utility/theme-default';

import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import 'react-table/react-table.css';
import 'react-select/dist/react-select.css';

import store from './store';
import routes from './routes';

injectTapEventPlugin();


ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={ThemeDefault}>
      <Router routes={routes} history={hashHistory}/>
    </MuiThemeProvider>
  </Provider>, document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js